import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PlayerJackpotWin } from '@/api/common';
import { ButtonClose } from '@/components/buttons';
import { ImageComponent } from '@/components/Image';
import { JackpotGemsWinPack } from '@/components/JackpotGemsPack';
import { amountWithCurrencySymbol } from '@/helpers/currency';
import { useCommonStore } from '@/store';

import { ScJackpotWinnerModal } from './styled';

interface JackpotWinnerModalProps {
  onClose: () => void;
  jackpotWin: PlayerJackpotWin;
}
export const JackpotWinnerModal: FC<JackpotWinnerModalProps> = ({
  onClose,
  jackpotWin,
}) => {
  const { t } = useTranslation('jackpot');
  const activeJackpot = useCommonStore.use.activeJackpot();
  const isMobileDevice = useCommonStore.use.isMobileDevice();

  const buttonCloseProps = useMemo(
    () => (isMobileDevice ? { top: 16, right: 16 } : { top: 12, right: 12 }),
    [isMobileDevice]
  );

  const prize = useMemo(
    () =>
      amountWithCurrencySymbol(
        activeJackpot?.currency || 'USD',
        jackpotWin.amountCents / 100
      ),
    [activeJackpot?.currency, jackpotWin.amountCents]
  );

  return (
    <ScJackpotWinnerModal>
      <ButtonClose onClick={onClose} {...buttonCloseProps} />
      <ImageComponent
        src="/jackpot/logo.webp"
        alt="jackpot logo"
        className="logo"
      />
      <div className="congrats">{t('congrats')}</div>
      <div className="prize">
        <div className="sum">{prize}</div>
        <div className="win-text">{t('jackpotYouWon')}</div>
      </div>

      <JackpotGemsWinPack />
    </ScJackpotWinnerModal>
  );
};
